import { Input } from '@atoms/index';

export interface GuestContactData {
  fullName: string;
  email: string;
  phone: string;
}

interface GuestContactFormProps {
  value: GuestContactData;
  onChange: (value: GuestContactData) => void;
}

export const GuestContactForm = ({ value, onChange }: GuestContactFormProps) => {
  return (
    <div className="space-y-4">
      <Input
        label="Ad Soyad"
        placeholder="Adınız ve soyadınız"
        value={value.fullName}
        onChange={(e) => onChange({ ...value, fullName: e.target.value })}
        required
        autoComplete="name"
      />
      <Input
        label="E-posta"
        placeholder="ornek@email.com"
        type="email"
        value={value.email}
        onChange={(e) => onChange({ ...value, email: e.target.value })}
        required
        autoComplete="email"
      />
      <Input
        label="Telefon Numarası"
        placeholder="05XX XXX XX XX"
        type="tel"
        value={value.phone}
        onChange={(e) => onChange({ ...value, phone: e.target.value })}
        required
        autoComplete="tel"
      />
      <p className="text-xs text-gray-500">
        Sipariş takip bağlantısı e-posta adresinize gönderilecektir. Telefon numaranız teslimat için kullanılır.
      </p>
    </div>
  );
};
